// chat setting options
import { AVAILABLE_VOICES } from '@/app/lib/types/voice';

export interface UserChatSetting {
  languageModel: string;
  imageGenMode: ImageGenMode;
  ttsId: string;
  imageModel: string;
}

export enum ImageGenMode {
    AUTO = 'auto',
    OFF = 'off',
}

export interface LanguageModel {
  id: string;
  name: string;
  context: string;
  price: number;
}

export interface ImageGenModel {
  id: string;
  name: string;
  description: string;
  price: number;
}

export const ImageGenPrice: number = 20;
export const TwoInputImageGenPrice: number = 30;
export const CallPerMessagePrice: number = 4;
export const LiveChatPerMessagePrice: number = 6;

export const imageGenModels: Record<string, ImageGenModel> = {
  'kontext': { // qwen
    id: 'kontext',
    name: 'Kontext',
    description: 'Fast and balanced. Medium safety filter.',
    price: 20
  },
  'banana': {
    id: 'banana',
    name: 'Nano Banana',
    description: 'Most advanced. Strong safety filter.',
    price: 20
  }
};

export const languageModels: Record<string, LanguageModel> = {
  'nemo-8k': {
    id: 'nemo-8k',
    name: 'Nemo',
    context: '8k',
    price: 0
  },
  'deepseek-v3-16k': {
    id: 'deepseek-v3-16k',
    name: 'DeepSeek',
    context: '16k',
    price: 0
  },
  // 'gemini-flash-20-16k': {
  //   id: 'gemini-flash-20-16k',
  //   name: 'Gemini Flash',
  //   context: '16k',
  //   price: 15
  // },
};

/**
 * Get the price of the current language model from global chat settings
 * @param currentLanguageModel - The current language model ID from global chat settings
 * @returns The price of the current model, or 1 as fallback if model not found
 */
export function getCurrentModelPrice(currentLanguageModel: string): number {
  const model = languageModels[currentLanguageModel];
  return model ? model.price : 1; // Fallback to 1 if model not found
}

/**
 * Get the price of the current voice from global chat settings
 * @param currentTtsId - The current voice ID (rita_voice_id) from global chat settings
 * @returns The price of the current voice, or 0 as fallback if voice not found
 */
export function getCurrentVoicePrice(currentTtsId: string): number {
  const voice = AVAILABLE_VOICES.find(v => v.rita_voice_id === currentTtsId);
  return voice ? voice.price : 0; // Fallback to 0 if voice not found
}

/**
 * Get the price of the current image generation model from global chat settings
 * @param currentImageModel - The current image model ID from global chat settings
 * @returns The price of the current image model, or 20 as fallback if model not found
 */
export function getCurrentImageModelPrice(currentImageModel: string): number {
  const model = imageGenModels[currentImageModel];
  return model.price;
}
